// extracted by mini-css-extract-plugin
module.exports = {"hashtagsList":"styles_hashtagsList__2H8a5","hashtagItem":"styles_hashtagItem__3gd_g"};